import { initializeApp } from "firebase/app";
import { getFirestore, doc, deleteDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyABogr6mLaiIh2lPv2j8pbThtn3Yxr_Cp4",
  authDomain: "nubmemes-b9c6b.firebaseapp.com",
  projectId: "nubmemes-b9c6b",
  storageBucket: "nubmemes-b9c6b.appspot.com",
  messagingSenderId: "185323050746",
  appId: "1:185323050746:web:1b620f985a2ef44c509b43",
  databaseURL: "https://nubmemes-b9c6b-default-rtdb.firebaseio.com/"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

async function deleteImage(id) {
  try {
    const docRef = doc(db, "memes_ai_final", id);
    await deleteDoc(docRef);
    console.log(id)
    alert("Deleted image, please allow 2 hours for the server to reflect this update.")
  } catch (error) {
    console.log(error)
  }
}

export { db, deleteImage };
